import { ArrowRightOutlined, PlusCircleFilled } from '@ant-design/icons';
import { Col, Popconfirm, Row, Table, Typography } from 'antd';
import { useEffect, useState } from 'react';

import { useOfficialStore } from '@hooks/OfficialStoreContext';
import { FullScreenModal } from '@styles/globals';
import * as S from '../../styles';
import RepresentativePriceTablesForm from '../RepresentativePriceTablesForm';
import './styles.css';

const { Title } = Typography;

interface RepresentativePriceTablesPanelProps {}

const RepresentativePriceTablesPanel: React.FC<RepresentativePriceTablesPanelProps> = () => {
  const [modalAddPriceTableIsVisible, setModalAddPriceTableIsVisible] = useState(false);
  const [priceTables, setPriceTables] = useState<any[]>([]);

  const { deleteRepresentativePriceTableFromOfficialStore, actualOfficialStore } = useOfficialStore();

  const onCloseAddPriceTableModal = () => setModalAddPriceTableIsVisible(false);
  const onShowAddPriceTableModal = () => setModalAddPriceTableIsVisible(true);

  useEffect(() => {
    if (Object.keys(actualOfficialStore).length) {
      setPriceTables(
        actualOfficialStore.representativePriceTables.sort((a, b) => {
          if (a.priceTableCode > b.priceTableCode) return 1;
          if (a.priceTableCode < b.priceTableCode) return -1;
          return 0;
        }),
      );
    }
  }, [actualOfficialStore, setPriceTables]);

  const onUnbind = (priceTableCode: number, stateCode: string) => {
    deleteRepresentativePriceTableFromOfficialStore(actualOfficialStore.officialStoreId, priceTableCode);
  };

  const columns = [
    {
      title: 'Tabela de Preço',
      render: (priceTable: any) => (
        <Popconfirm
          title={`Tem certeza que deseja desvincular a Tabela de Preço?`}
          onConfirm={() => onUnbind(priceTable.priceTableCode, priceTable.stateCode)}
          okText="Sim"
          cancelText="Não"
        >
          <strong className="strong-price-table">
            #{priceTable.priceTableCode} <ArrowRightOutlined style={{ fontSize: '10px' }} /> {priceTable.description}
          </strong>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Col xs={24} sm={24} lg={24} xxl={12} className="d-flex">
      <S.Panel>
        <Row justify="space-between">
          <Col>
            <Title level={4} style={{ color: '#555' }}>
              Tabelas de Preço dos representantes
            </Title>
          </Col>

          <Col>
            <S.CustomButton type="primary" onClick={onShowAddPriceTableModal} noMargin>
              <PlusCircleFilled /> Vincular Tabelas de Preço
            </S.CustomButton>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col span={24}>
            <Table
              columns={columns}
              dataSource={priceTables}
              pagination={{ pageSize: 4 }}
              rowKey={(record, i) => {
                return `${record.officialStoreId}-${record.priceTableCode}-${i}`;
              }}
              scroll={{ x: 800 }}
            />
          </Col>
        </Row>
      </S.Panel>

      <FullScreenModal
        destroyOnClose={true}
        visible={modalAddPriceTableIsVisible}
        onOk={onCloseAddPriceTableModal}
        onCancel={onCloseAddPriceTableModal}
        footer={null}
        forceRender={false}
      >
        <RepresentativePriceTablesForm />
      </FullScreenModal>
    </Col>
  );
};

export default RepresentativePriceTablesPanel;
